/**
 * The `{{variable}}` categories a rejection email offers — one source shared
 * by the composer's insert picker (`RejectEmailComposer`) and the send-time
 * validator (`useRejection`), so they can never disagree about which tokens
 * are valid (ENG-3856).
 *
 * Mirrors the backend's own view for this template kind
 * (`candidate_application_rejected` in `src/constants/templates-category.ts`)
 * minus categories a rejection has no context for (interview, schedule,
 * referral, assessment). `survey` stays: a rejection can attach a survey, and
 * without it here the picker has no "Survey" tab to insert the token from
 * (the composer's own survey toolbar button still works, but nothing here
 * offers it alongside the other variables).
 */
export const REJECTION_EMAIL_VARIABLES_VIEW = [
  'sender',
  'job',
  'candidate',
  'org',
  'survey',
];
